export const FINANCIAL_TRANSACTIONS_TABLE_SETTING_KEY =
  'financialTransactionsTableColumns'

export const FINANCIAL_TRANSACTIONS_COLUMNS = [
  { value: 'index', label: 'Номер строки' },
  { value: 'course', label: 'Курс/Класс/Баланс' },
  { value: 'amount', label: 'Сумма' },
  { value: 'promoDiscountAmount', label: 'Скидка' },
  { value: 'date', label: 'Дата' },
  { value: 'accessExtendedBy', label: 'Продлено/списано на' },
  { value: 'paidFrom', label: 'Оплачено с' },
  { value: 'paidTo', label: 'Оплачено до' },
  { value: 'paymentFormat', label: 'Формат оплаты' },
  { value: 'status', label: 'Статус' },
  {
    value: 'manualRenewalComment',
    label: 'Комментарий ручного продления',
  },
  { value: 'remove', label: 'Удаление строки' },
]

export const FINANCIAL_TRANSACTIONS_EXCLUDED_COLUMNS_BY_ROLE = {
  children: ['remove'],
  parent: ['remove'],
}

export const FINANCIAL_TRANSACTIONS_ACCEPTED_ROLES = [
  'admin',
  'junior-admin',
  'personal-manager',
  'hr-manager',
  'seminarian',
  'senior-seminarian',
  'sales-manager',
  'head-of-sales',
  'children',
  'parent',
]
